/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CostBreakdownBucketTotals,
    CostBreakdownBucketTotalsFromJSON,
    CostBreakdownBucketTotalsFromJSONTyped,
    CostBreakdownBucketTotalsToJSON,
} from './CostBreakdownBucketTotals';
import {
    CostBreakdownDisplayFee,
    CostBreakdownDisplayFeeFromJSON,
    CostBreakdownDisplayFeeFromJSONTyped,
    CostBreakdownDisplayFeeToJSON,
} from './CostBreakdownDisplayFee';
import {
    CostBreakdownDisplaySubtotal,
    CostBreakdownDisplaySubtotalFromJSON,
    CostBreakdownDisplaySubtotalFromJSONTyped,
    CostBreakdownDisplaySubtotalToJSON,
} from './CostBreakdownDisplaySubtotal';
import {
    CostBreakdownDisplayTax,
    CostBreakdownDisplayTaxFromJSON,
    CostBreakdownDisplayTaxFromJSONTyped,
    CostBreakdownDisplayTaxToJSON,
} from './CostBreakdownDisplayTax';
import {
    CostBreakdownNetSubtotal,
    CostBreakdownNetSubtotalFromJSON,
    CostBreakdownNetSubtotalFromJSONTyped,
    CostBreakdownNetSubtotalToJSON,
} from './CostBreakdownNetSubtotal';
import {
    CostBreakdownNetTax,
    CostBreakdownNetTaxFromJSON,
    CostBreakdownNetTaxFromJSONTyped,
    CostBreakdownNetTaxToJSON,
} from './CostBreakdownNetTax';
import {
    CostBreakdownNetTotal,
    CostBreakdownNetTotalFromJSON,
    CostBreakdownNetTotalFromJSONTyped,
    CostBreakdownNetTotalToJSON,
} from './CostBreakdownNetTotal';
import {
    CostComponent,
    CostComponentFromJSON,
    CostComponentFromJSONTyped,
    CostComponentToJSON,
} from './CostComponent';

/**
 * 
 * @export
 * @interface CostBreakdown
 */
export interface CostBreakdown {
    /**
     * 
     * @type {CostBreakdownDisplaySubtotal}
     * @memberof CostBreakdown
     */
    display_subtotal: CostBreakdownDisplaySubtotal;
    /**
     * 
     * @type {CostBreakdownDisplayFee}
     * @memberof CostBreakdown
     */
    display_fee: CostBreakdownDisplayFee;
    /**
     * 
     * @type {CostBreakdownDisplayTax}
     * @memberof CostBreakdown
     */
    display_tax: CostBreakdownDisplayTax;
    /**
     * 
     * @type {CostBreakdownNetSubtotal}
     * @memberof CostBreakdown
     */
    net_subtotal: CostBreakdownNetSubtotal;
    /**
     * 
     * @type {CostBreakdownNetTax}
     * @memberof CostBreakdown
     */
    net_tax: CostBreakdownNetTax;
    /**
     * 
     * @type {CostBreakdownNetTotal}
     * @memberof CostBreakdown
     */
    net_total: CostBreakdownNetTotal;
    /**
     * List of the line item breakdown.
     * @type {Array<CostComponent>}
     * @memberof CostBreakdown
     */
    components?: Array<CostComponent>;
    /**
     * 
     * @type {CostBreakdownBucketTotals}
     * @memberof CostBreakdown
     */
    bucket_totals: CostBreakdownBucketTotals;
}

export function CostBreakdownFromJSON(json: any): CostBreakdown {
    return CostBreakdownFromJSONTyped(json, false);
}

export function CostBreakdownFromJSONTyped(json: any, ignoreDiscriminator: boolean): CostBreakdown {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'display_subtotal': CostBreakdownDisplaySubtotalFromJSON(json['display_subtotal']),
        'display_fee': CostBreakdownDisplayFeeFromJSON(json['display_fee']),
        'display_tax': CostBreakdownDisplayTaxFromJSON(json['display_tax']),
        'net_subtotal': CostBreakdownNetSubtotalFromJSON(json['net_subtotal']),
        'net_tax': CostBreakdownNetTaxFromJSON(json['net_tax']),
        'net_total': CostBreakdownNetTotalFromJSON(json['net_total']),
        'components': !exists(json, 'components') ? undefined : ((json['components'] as Array<any>).map(CostComponentFromJSON)),
        'bucket_totals': CostBreakdownBucketTotalsFromJSON(json['bucket_totals']),
    };
}

export function CostBreakdownToJSON(value?: CostBreakdown | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'display_subtotal': CostBreakdownDisplaySubtotalToJSON(value.display_subtotal),
        'display_fee': CostBreakdownDisplayFeeToJSON(value.display_fee),
        'display_tax': CostBreakdownDisplayTaxToJSON(value.display_tax),
        'net_subtotal': CostBreakdownNetSubtotalToJSON(value.net_subtotal),
        'net_tax': CostBreakdownNetTaxToJSON(value.net_tax),
        'net_total': CostBreakdownNetTotalToJSON(value.net_total),
        'components': value.components === undefined ? undefined : ((value.components as Array<any>).map(CostComponentToJSON)),
        'bucket_totals': CostBreakdownBucketTotalsToJSON(value.bucket_totals),
    };
}

